import script from "./BoletoCheckout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoletoCheckout.vue?vue&type=script&setup=true&lang=ts"

import "./BoletoCheckout.vue?vue&type=style&index=0&id=bf90f40e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf90f40e"]])

export default __exports__